import { reactive } from './reactive';
const AsyncFunction = (async () => { }).constructor;
let asyncComponentInstaller = null;
function setComponentKey(key) {
    this.k = key;
    return this;
}
const propsProxyHandler = {
    get(target, key) {
        return target[0]?.[key];
    },
    has(target, key) {
        return key in (target[0] || {});
    },
    ownKeys(target) {
        return Reflect.ownKeys(target[0] || {});
    },
    getOwnPropertyDescriptor(target, key) {
        const source = target[0];
        return source && {
            configurable: true,
            enumerable: true,
            writable: true,
            value: source[key],
        };
    },
    set(target, key, value) {
        return !!target[0] && Reflect.set(target[0], key, value);
    },
};
const narrowedPropsHandler = {
    get(target, key) {
        return target.k.includes(key)
            ? target.s[key]
            : undefined;
    },
    set(target, key, value) {
        if (!target.k.includes(key))
            return false;
        return Reflect.set(target.s, key, value);
    },
};
export function pick(source, ...keys) {
    return keys.length
        ? new Proxy({
            k: keys,
            s: source,
        }, narrowedPropsHandler)
        : source;
}
export function component(factory, options) {
    if (options || factory.constructor === AsyncFunction) {
        if (!asyncComponentInstaller) {
            throw Error('Async runtime missing.');
        }
        return asyncComponentInstaller(factory, options);
    }
    return ((input, events) => ({
        h: factory,
        k: undefined,
        p: input,
        e: events,
        key: setComponentKey,
    }));
}
export function installAsyncComponentInstaller(installer) {
    asyncComponentInstaller = installer;
}
export function isCmp(value) {
    return !!value && typeof value === 'object' && 'h' in value;
}
export function createPropsProxy(source, factory, events) {
    const box = reactive({ 0: source, 1: factory, 2: events });
    const emit = ((event, payload) => {
        const handler = box[2]?.[event];
        if (typeof handler === 'function')
            handler(payload);
    });
    return [
        new Proxy(box, propsProxyHandler),
        emit,
        box,
    ];
}
